import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAllClaims } from "../../store/action/claim";
import { CircularProgress, Typography } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
const useStyles = makeStyles({
    statusContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: 100,
    },
    statusSection: {
        flex: 1,
        height: 87,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 10,
        backgroundColor: 'rgba(255, 255, 255, 1)',
        border: '1px solid rgba(255, 255, 255, 1)',
        opacity: 1,
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '18px',
        color: 'rgba(181, 181, 195, 1)',
        position: 'relative',
        paddingTop: 20,
        paddingBottom: 10,
        paddingLeft: 17,
    },
    firstSection: {
        borderTopLeftRadius: 9,
        borderBottomLeftRadius: 9,
    },
    lastSection: {
        borderTopRightRadius: 9,
        borderBottomRightRadius: 9,
    },
    sectionLine: {
        content: '""',
        position: 'absolute',
        top: 7,
        bottom: 5,
        right: 0,
        width: 1,
        backgroundColor: 'rgba(244, 241, 249, 1)',
    },
    sectionText: {
        fontFamily: 'Poppins',
        fontSize: 20,
        fontWeight: 600,
        color: 'rgba(70, 78, 95, 1)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 5,
    },
});

const StatusSummary = (props) => {
    const classes = useStyles();
    const { claimData, loading } = props;

    // 🔥 BUSINESS GROUPS

    const OPEN_STATUSES = [
        'OPEN',

        'AWAITING_SERVICE_PROPOSAL',
        'AWAITING_ASSIGNMENT',
        'AWAITING_INSPECTOR_DESIGNATION',
        'AWAITING_REPARIRER_DESIGNATION',
        'AWAITING_INSPECTION',
        'VEHICLE_INSPECTED',
        'AWAITING_QUOTATION',
        'AWAITING_QUOTATION_APPROVAL',
        'AWAITING_ESTIMATE_CAR_REPAIR_ENTRY_DATE',
        'AWAITING_PRELIMINARY_REPORT',
        'AWAITING_CUSTOMER_CALL',
        'AWAITING_START_OF_REPAIRS',
        'AWAITING_REPAIR',
        'AWAITING_PICTUE_AND_INVOICE',
        'AWAITING_INVOICE_APPROVAL',
        'AWAITING_DISPATCH_OF_RELEASE_FORM',
        'AWAITING_FINAL_REPORT',
        'AWAITING_PAYMENT_APPROVAL',

        'AWAITING_SERVICE_ASSIGNMENT',
        'AWAITING_APPOINTMENT_PROPOSAL',
        'AWAITING_PAYMENT',
        'AWAITING_PICTURES_BEFORE_REPARATION',
        'AWAITING_CLIENT_PAYMENT',
        'AWAITING_PROVIDER_INVOICE',
        'AWAITING_REPAIRER_INVOICE',
        'AWAITING_ERECOUR_INSERSION',
        'AWAITING_PAYMENT_PROOF',
        'AWAITING_INSPECTOR_INVOICE',
        'AWAITING_CALCULATION_CUSTOMER_PART',
        'AWAITING_REPAIRATION',

        'NO_FOLLOW_UP',
        'PAYED',
    ];

    const IN_PROGRESS_STATUSES = OPEN_STATUSES.filter(
        (s) => s !== 'OPEN'
    );

    const CLOSED_STATUSES = [
        'ARCHIVED_CLAIM',
        'CLOSED',
    ];

    // 🧠 Build lookup map from API data
    const statusMap = (claimData || []).reduce((acc, item) => {
        acc[item.status] = item.count;
        return acc;
    }, {});

    const summary = {
        openCount: 0,
        pendingCount: 0,
        closedCount: 0,
    };


    OPEN_STATUSES.forEach((status) => {
        summary.openCount += statusMap[status] || 0;
    });


    IN_PROGRESS_STATUSES.forEach((status) => {
        summary.pendingCount += statusMap[status] || 0;
    });


    CLOSED_STATUSES.forEach((status) => {
        summary.closedCount += statusMap[status] || 0;
    });

    const renderValue = (value) =>
        loading ? (
            <Skeleton variant="text" width={30} height={24} animation="wave" />
        ) : (
            value
        );

    return (
        <div className={classes.statusContainer}>
            <div className={`${classes.statusSection} ${classes.firstSection}`}>
                Sinistre Ouverts
                <span className={classes.sectionText}>
                    {renderValue(summary.openCount)}
                </span>
                <span className={classes.sectionLine}></span>
            </div>

            <div className={classes.statusSection}>
                Sinistre en cours
                <span className={classes.sectionText}>
                    {renderValue(summary.pendingCount)}
                </span>
                <span className={classes.sectionLine}></span>
            </div>

            <div className={`${classes.statusSection} ${classes.lastSection}`}>
                Sinistre cloturés
                <span className={classes.sectionText}>
                    {renderValue(summary.closedCount)}
                </span>
            </div>
        </div>
    );
};



export default StatusSummary;
